/**
 * Simple utility to detect which landing experience to show based on URL
 */

export type LandingType = 'business' | 'consumer';

export const detectLandingType = (): LandingType => {
  if (typeof window === 'undefined') {
    return 'business'; // Default for SSR
  }

  const hostname = window.location.hostname;
  const path = window.location.pathname;
  
  // Consumer landing triggers:
  // - app.helpgenie.com subdomain
  // - /consumer path on main domain
  if (hostname === 'app.helpgenie.com' || path.startsWith('/consumer')) {
    return 'consumer';
  }
  
  // Default: business landing
  return 'business';
};

export const isConsumerLanding = (): boolean => {
  return detectLandingType() === 'consumer';
};

export const isBusinessLanding = (): boolean => {
  return detectLandingType() === 'business';
};